import React from 'react';
import { Mail, Search, Settings, X, AlignLeft, LogOut, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';

const Header = ({
    isSidebarOpen,
    setIsSidebarOpen,
    setActiveFolder,
    setIsComposeOpen,
    searchQuery,
    setSearchQuery,
    user,
    onLogout,
    onOpenSettings,
    isCalendarPanelOpen,
    setIsCalendarPanelOpen
}) => {
    const userInitial = user?.name?.charAt(0).toUpperCase() || 'U';

    return (
        <header className="glass header-container" style={{
            height: 'var(--header-height)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 20px',
            color: 'var(--text-main)',
            borderBottom: '1px solid var(--border-glass)',
            flexShrink: 0,
            zIndex: 110
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <motion.div
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="mobile-only"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    style={{ cursor: 'pointer', color: 'var(--primary)' }}
                >
                    {isSidebarOpen ? <X size={24} /> : <AlignLeft size={24} />}
                </motion.div>

                <div
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                    onClick={() => { setActiveFolder('INBOX'); setIsComposeOpen(false); setIsSidebarOpen(false); }}
                >

                    <img
                        src="/Artboard 4 copy@3x (1).png"
                        alt="Xevyte Mail"
                        style={{
                            height: '60px',
                            width: 'auto',
                            objectFit: 'contain',
                            transform: 'scale(2.5)',
                            transformOrigin: 'left center',
                            marginLeft: '0px'
                        }}
                    />
                </div>
            </div>

            <div className="hide-mobile search-container" style={{
                flex: 1,
                maxWidth: '480px',
                margin: '0 32px',
                height: '42px',
                background: 'var(--bg-secondary)',
                borderRadius: '12px'
            }}>
                <Search size={16} color="var(--text-dim)" />
                <input
                    placeholder="Search messages..."
                    className="search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: '0 12px' }}
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <button
                    onClick={() => setIsCalendarPanelOpen(!isCalendarPanelOpen)}
                    title={isCalendarPanelOpen ? "Close Calendar Panel" : "Open Calendar Panel"}
                    style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: isCalendarPanelOpen ? 'var(--primary)' : 'var(--text-main)',
                        background: 'var(--bg-secondary)',
                        border: '1px solid var(--border-glass)',
                        cursor: 'pointer',
                        marginRight: '8px',
                        padding: 0,
                        flexShrink: 0
                    }}
                >
                    <Calendar
                        size={20}
                        style={{
                            width: '20px',
                            height: '20px',
                            display: 'block',
                            color: isCalendarPanelOpen ? 'var(--primary)' : 'var(--text-main)'
                        }}
                    />
                </button>

                <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={onOpenSettings}
                    style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '10px',
                        background: 'var(--primary-glow)',
                        border: '1px solid var(--border-glass)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.9rem',
                        fontWeight: '700',
                        color: 'var(--primary)',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                    }}
                >
                    {userInitial}
                </motion.div>

                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={onLogout}
                    title="Logout"
                    className="btn-ghost"
                    style={{
                        padding: '8px',
                        color: 'var(--text-muted)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer'
                    }}
                >
                    <LogOut size={18} />
                    <span className="hide-mobile" style={{ fontSize: '0.9rem', fontWeight: '500' }}>Logout</span>
                </motion.button>
            </div>
        </header>
    );
};

export default Header;
